import useDatasHooks from "@/main-page/ctls/hooks/useDatasHooks";
import {deepClone, initTreeData} from "xmgoing-utils";
import useWatchHooks from "@/main-page/hooks/useWatchHooks";
import {useGridTableStore} from "@/store/modules/gridTableStore";
import {
  useComDataInterface
} from "@/main-page-base/ctls/dataCtls/xmRelQuery/interface/useComDataInterface";
import {useComEvent} from "@/main-page/ctls/hooks/useComEvent";
import GoingUtils from "@/utils/goingUtils";
import {useMultipleTabStore} from "@/store/modules/multipleTab";
import {
  applyMultiFieldTitles,
  getPrimaryTitleField,
  normalizeTitleIds,
} from "@/main-page-base/ctls/dataCtls/xmTreeCtl/utils/titleIdUtils";

/**
 * 初始化节点的id信息
 * @param nodeList
 */
const initNodeListId = function (nodeList, fieldNames) {
  if (nodeList && Array.isArray(nodeList)) {
    nodeList.forEach((recordDb) => {
      if (recordDb.key) {
        if (!recordDb.id) {
          recordDb.id = recordDb.key;
        }
      } else {
        recordDb.key = recordDb[unref(fieldNames).key]
      }
      if (recordDb && Array.isArray(recordDb.children)) {
        initNodeListId(recordDb.children, fieldNames);
      }
    })
  }
}
/**
 * 获取当前选择的记录信息
 * @param list
 * @param nodeId
 * @param findRecord
 */
export const getRecordById = function (list, nodeId, findRecord) {
  const fineItem = unref(list).filter((itemObj) => {
    return itemObj.id === nodeId;
  })[0];
  if (fineItem) {
    findRecord.target = fineItem;
  } else {
    unref(list).forEach((itemObj) => {
      if (unref(itemObj).children && unref(itemObj).children.length > 0) {
        getRecordById(unref(itemObj).children, nodeId, findRecord);
      }
    });
  }
}

export function useDataDealHooks({dataConfig, props, emits, events, selectedKeys}) {
  const gridTableStore: any = useGridTableStore();
  const tabStore = useMultipleTabStore();
  const showLoading = ref(false);
  const expandedKeys: any = ref([]);
  const treeList: any = ref([]);
  const fieldNames = computed(() => {
    const titleIds = normalizeTitleIds(unref(dataConfig).titleId);
    return {
      children: 'children',
      title: titleIds.length > 1 ? 'title' : getPrimaryTitleField(unref(dataConfig).titleId),
      key: unref(dataConfig).keyId || 'id'
    }
  });

  //接口方法
  const {
    afterLoadData
  } = useComDataInterface({emits, events});

  /**
   * 执行点击事件
   * @param record
   */
  const executeClickNodeEvent = function (record) {
    setTimeout(() => {
      const {clickEvent} = useComEvent({events});
      clickEvent('click', {record});
    }, 10)
  }
  /**
   * 数据查询相关
   */
  const {
    initCtlData,
    pageTotal,
  }: any = useDatasHooks({dataConfig});

  const clickFirstNode = function () {
    //是否选中第一行数据
    if (unref(dataConfig).selectOneRecord) {
      if (unref(treeList) && unref(treeList).length > 0) {
        selectedKeys.value = [unref(treeList)[0]['id']];
        executeClickNodeEvent(unref(treeList)[0]);
        setTimeout(() => {
          const {clickEvent} = useComEvent({events});
          clickEvent('click', {record: unref(treeList)[0]});
        }, 10)
      }
    }
  }

  const initBackList = function (nodeList) {
    afterLoadData && afterLoadData({records:nodeList});
    applyMultiFieldTitles(nodeList, unref(dataConfig).titleId);
    if (unref(dataConfig).showAllNode) {
      treeList.value = [
        {key: 'all', value: 'all', title: '全部', children: nodeList}
      ];
      unref(expandedKeys).push('all')
    } else {
      treeList.value = nodeList;
    }
    nextTick(() => {
      //加载完成后 ，选中第一行数据
      clickFirstNode();
    })
  }


  const initCtlDataFun = (inParams) => {
    if (unref(dataConfig).dataList && Array.isArray(unref(dataConfig).dataList) && unref(dataConfig).dataList.length > 0) {
      if (treeList.value && Array.isArray(treeList.value) && treeList.value.length > 0) {
        // 避免重复调用静态方法的写入
        return;
      }
      const list: any = deepClone(unref(dataConfig).dataList);
      list.forEach((itemDb) => {
        itemDb.id = itemDb.value;
        itemDb.key = itemDb.value;
        itemDb.title = itemDb.label;
      })
      treeList.value = list;
      
      if (unref(props)?.defaultValue) {
        // 选中默认值
        const item = treeList.value.find((item) => item.id === unref(props)?.defaultValue);
        if (item) {
          selectedKeys.value = [];
          unref(selectedKeys).push(unref(props)?.defaultValue);
          setTimeout(()=>{
            const {clickEvent} = useComEvent({events});
            clickEvent('click', {record: item});
          },10)
        }
      }
      return;
    }
    showLoading.value = true;
    initCtlData(({res}) => {
      if (res) {
        const {total, records} = res;
        if (records && Array.isArray(records)) {
          records.forEach((itemObj) => {
            if (itemObj['parentId'] === '') {
              itemObj['parentId'] = null;
            }
            itemObj['id'] = (itemObj['id'] + '');
            if (itemObj && itemObj.children) {
              itemObj.children.forEach((sonItem) => {
                sonItem['parentId'] = itemObj.id;
              })
            }
          });
          if (records) {
            pageTotal.value = total;
            const titleField = getPrimaryTitleField(unref(dataConfig).titleId);
            const nodeList = initTreeData(records, unref(expandedKeys), {
              key: unref(dataConfig).keyId || 'id',
              title: titleField
            }, parseInt(unref(dataConfig).expandType));
            initNodeListId(nodeList, fieldNames);
            initBackList(nodeList);
          } else if (Array.isArray(res)) {
            const titleField = getPrimaryTitleField(unref(dataConfig).titleId);
            const nodeList = initTreeData(res, unref(expandedKeys), {
              key: unref(dataConfig).keyId || 'id',
              title: titleField
            }, parseInt(unref(dataConfig).expandType));
            initBackList(nodeList);
          }
        }

      }

      // 去除空值
      expandedKeys.value = unref(expandedKeys).filter(item => !!item)

      showLoading.value = false;
    }, inParams)
    setTimeout(() => {
      showLoading.value = false;
    }, 1200)
  }

  //加载数据
  unref(dataConfig).autoLoadData && initCtlDataFun({});
  //如果默认不加载 又是全局变量
  if (unref(dataConfig) && !unref(dataConfig).autoLoadData && unref(dataConfig)['dateQueryType'] === 'vuexDef' && unref(dataConfig)['vuexName']) {
    initCtlDataFun({});
  }
  onMounted(() => {
    if (!GoingUtils.isDesFlag()) {
      if (unref(dataConfig) && unref(dataConfig).autoLoadData === false) {
        nextTick(() => {
          unref(dataConfig).autoLoadData = true;
        })
      }
    }
  })

  const flushList = function (params) {
    initCtlDataFun({...params});
  }

  //刷新数据
  const flushData = (params) => {
    nextTick(() => {
      initCtlDataFun({...params});
    })
  }

  //如果没有设置不加载数据
  if (unref(dataConfig).autoLoadData !== false) {
    //自动加载数据
    flushData({});
  } else {
    //如果是全局变量 则可以进行初始化
    if (unref(dataConfig)['dateQueryType'] === 'vuexDef' && unref(dataConfig)['vuexName']) {
      flushData({});
    }
  }

  useWatchHooks({initCtlData: initCtlDataFun, dataConfig});

  const tableObj = ref(gridTableStore.getGridObjByKey(unref(props).key));
  if (unref(tableObj)) {
    watch(() => unref(tableObj)['clearCtlDate'], () => {
      treeList.value = [];
    })
  }

  onActivated(() => {
    const {delPageList} = tabStore;
    //如果该页面被删除了 则进入则需要刷新数据
    if (delPageList && delPageList[GoingUtils.getPageCode()] === true) {
      flushData({});
      nextTick(() => {
        delPageList[GoingUtils.getPageCode()] = false;
      })

      if (unref(selectedKeys) && unref(selectedKeys).length > 0) {
        const findRecord = {target: null}
        getRecordById(treeList, unref(selectedKeys)[0], findRecord);
        if (findRecord.target) {
          executeClickNodeEvent(findRecord.target);
        }
      }
    }

  });

  return {
    fieldNames,
    initCtlDataFun,
    flushList,
    expandedKeys,
    treeList,
    showLoading
  }
}

